import React from "react"
import renderStar from "./renderStars"

const TotalReviewScore = ({ yotpoProductBottomLine }) => {
  if (!yotpoProductBottomLine) {
    return null
  }

  return (
    <div className="font-darkGrey mt-[12px] flex flex-row text-[13px]">
      {yotpoProductBottomLine?.score && (
        <>
          <div className="flex flex-row">
            {renderStar(yotpoProductBottomLine?.score)}
          </div>
          <div className="ml-[5px] font-sans font-black">
            {parseInt(yotpoProductBottomLine?.score)}{" "}
          </div>
        </>
      )}
      {yotpoProductBottomLine?.totalReviews > 0 && (
        <div className="px-[5px]">|</div>
      )}
      <a href="#reviews" className="hover:text-darkBlue">
        <div className="underline decoration-darkGrey">
          {yotpoProductBottomLine?.totalReviews > 0
            ? yotpoProductBottomLine?.totalReviews
            : 0}{" "}
          {yotpoProductBottomLine?.totalReviews === 1 ? "Review" : "Reviews"}
        </div>
      </a>
    </div>
  )
}

export default TotalReviewScore
